import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=56595fc4&scoped=true&"
import script from "./MarkdownEditor.vue?vue&type=script&lang=ts&"
export * from "./MarkdownEditor.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=56595fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56595fc4",
  null
  
)

export default component.exports